/**
 * For role=button tabbing 
 * 
 * This is a direct edit that was made to main.js.
 * Preserved here to maintain functionality.
 */

(function (Drupal, $) {

  /**
   * JS Behaviour.
   *
   * @type {{attach: Drupal.behaviors.tabButton.attach}}
   */

  Drupal.behaviors.tabButton = {
    attach: function (context, settings){
      $('.cta-area').click(function(e) {
        var parent = $(this).parent().parent();  // or $.closest, or any travese to get to the div that should get the click
        parent.trigger('click');
        e.preventDefault();
        e.stopPropagation();
        return false;
    });
      // setTimeout(()=>{
      //   document.querySelectorAll('div[role="button"]').forEach(el => {
      //     el.addEventListener('keydown', e => {
      //         const keyDown = e.key !== undefined ? e.key : e.keyCode;
      //         if ( (keyDown === 'Enter' || keyDown === 13) || (['Spacebar', ' '].indexOf(keyDown) >= 0 || keyDown === 32)) {
      //             // (prevent default so the page doesn't scroll when pressing space)
      //             e.preventDefault();
      //             jQuery(el).trigger('click') ;
      //         }
      //     });

      //     if(!el.hasAttribute('tabindex')){
      //       el.setAttribute('tabindex','0');
      //     }
      //   });
      // },1000)
    }
  }
})(Drupal, jQuery);

